import { NextPage } from "next"
import { useRouter } from "next/router"
import { ReconciliationList } from "src/features/reconciliations/components/ReconciliationList"
import Head from "next/head"
import { Heading } from "@smooth/design-system-components"
import { DefaultLayout } from "src/components/Layout"

const Page: NextPage = () => {
  const router = useRouter()
  if (!router.isReady) return null
  const page = Math.max(Number(router.query.page) || 1, 1)

  return (
    <DefaultLayout>
      <Head>
        <title>消し込み | for Smoother</title>
      </Head>
      <div style={{ height: "calc(100vh - 90px)", overflowY: "auto" }}>
        <div data-smooth-ds className="mx-auto max-w-[900px] px-4 py-6 sm:px-6 lg:px-8">
          <div className="mb-6 flex flex-col gap-2">
            <Heading level={1}>消し込み</Heading>
          </div>
          <ReconciliationList page={page} />
        </div>
      </div>
    </DefaultLayout>
  )
}

export default Page
